export const translations = {
  en: {
    navigation: {
      home: 'Home',
      products: 'Products',
      services: 'Services',
      team: 'Team',
      about: 'About Us',
      contact: 'Contact',
      getStarted: 'Get Started',
      language: 'Language',
    },
    hero: {
      badge: 'Intelligent Systems, Crystal Clear Solutions.',
      title1: 'Build The Future',
      title2: 'With Lakehouse',
      subtitle: 'As a forward-thinking startup, we deliver cutting-edge AI, software, and strategic consultancy to accelerate your business transformation.',
      cta1: 'Start Your Project',
      cta2: 'Explore Services',
      value1_title: 'Innovation',
      value1_desc: 'At our core',
      value2_title: 'Partnership',
      value2_desc: 'In our approach',
      value3_title: 'Scalability',
      value3_desc: 'In our design',
    },
    products: {
      badge: 'Our Products',
      title1: 'Engineered for',
      title2: 'Modern Challenges',
      subtitle: 'Discover our flagship products, designed to provide clarity and security in a complex digital world.',
      learnMore: 'Learn More',
      items: [
        {
          title: 'TSEG - The Social Engineering Guard',
          description: 'Advanced social engineering awareness platform that trains and protects your organization against phishing, pretexting, and human-centric cyber attacks.',
          features: ['Realistic Attack Simulations', 'Real-time Threat Assessment', 'Behavioral Analytics', 'Custom Security Training'],
        },
        {
          title: 'Nexus Pay',
          description: 'A unified payment ecosystem for all residential utilities. Streamline billing, payments, and community management with intelligent automation.',
          features: ['All-in-One Billing Hub', 'Secure Payment Gateway', 'Usage Analytics Dashboard', 'Resident Communication Portal'],
        },
        {
          title: 'Sentinel AI',
          description: 'Your autonomous cybersecurity expert. Sentinel continuously monitors, detects, and neutralizes threats with advanced AI-powered penetration testing.',
          features: ['24/7 Autonomous Monitoring', 'AI-Powered Penetration Testing', 'Vulnerability Assessment', 'Automated Incident Response'],
        },
      ],
    },
    services: {
      badge: 'Our Services',
      title1: 'Expert',
      title2: 'Technology Services',
      subtitle: 'Comprehensive technology services delivered by our team of experts to accelerate your digital transformation and drive business growth.',
      processTitle: 'Our Agile Process',
      processSubtitle: 'A proven methodology that ensures successful project delivery and exceptional results.',
      items: [
        { title: 'AI Development & Implementation', description: 'Custom AI solutions tailored to your business needs, from machine learning models to neural networks and automated decision systems.', benefits: ['Custom ML Models', 'Natural Language Processing', 'Computer Vision', 'Predictive Analytics'] },
        { title: 'Software Development', description: 'Full-stack development services creating scalable, secure, and performant applications using the latest technologies and frameworks.', benefits: ['Web Applications', 'Mobile Apps', 'Cloud Solutions', 'API Development'] },
        { title: 'Automation Consultancy', description: 'Strategic automation consulting to streamline your processes, reduce costs, and improve efficiency through intelligent automation.', benefits: ['Process Optimization', 'Workflow Automation', 'RPA Implementation', 'Integration Solutions'] },
        { title: 'Data Analytics', description: 'Transform your data into actionable insights with advanced analytics, visualization, and business intelligence solutions.', benefits: ['Business Intelligence', 'Data Visualization', 'Real-time Analytics', 'Custom Reports'] },
        { title: 'System Design & Architecture', description: 'Enterprise-grade system architecture and design services to build robust, scalable, and maintainable technology infrastructure.', benefits: ['Architecture Planning', 'Scalability Design', 'Performance Optimization', 'Security Implementation'] }
      ],
      processSteps: [
        { step: '01', title: 'Discovery', desc: 'Understanding your needs and goals' },
        { step: '02', title: 'Strategy', desc: 'Developing the perfect solution approach' },
        { step: '03', title: 'Implementation', desc: 'Building and deploying your solution' },
        { step: '04', title: 'Support', desc: 'Ongoing maintenance and optimization' }
      ]
    },
    team: {
        badge: 'Our Expertise',
        title1: 'Elite Professionals',
        title2: 'Proven Excellence',
        subtitle: 'With over 5 years of experience in AI, software engineering development, consultancy, data science, and analytics, our team brings deep technical expertise and diverse industry experience.',
        areas: [
            { title: 'AI & Machine Learning', description: 'Our team specializes in cutting-edge artificial intelligence and machine learning solutions, backed by advanced degrees and extensive research experience.', background: 'Master\'s Degrees • AI Research • Neural Networks' },
            { title: 'Software Engineering', description: 'Full-stack developers and architects with software engineering licenses and degrees from Romania\'s top universities, delivering scalable enterprise solutions.', background: 'Licensed Engineers • Top University Degrees • Enterprise Architecture' },
            { title: 'Data Science & Analytics', description: 'Expert data scientists and analysts who transform complex datasets into actionable business insights using advanced statistical methods.', background: 'Advanced Analytics • Statistical Modeling • Business Intelligence' },
            { title: 'Technical Consultancy', description: 'Experienced consultants who have worked across government, private sector, and research institutions, delivering strategic technology guidance.', background: 'Government Projects • Private Sector • Research Experience' },
        ],
        years: 'Years of Experience',
        areasLabel: 'Core Expertise Areas',
        academic: 'Academic Background',
        industry: 'Industry Experience',
    },
    about: {
      badge: 'Our Mission',
      title1: 'Pioneering',
      title2: 'Digital Clarity',
      subtitle1: 'From Complex Problems to',
      subtitle2: 'Elegant Solutions',
      p1: 'Lakehouse Technologies was founded on the principle that even the most complex technology should feel clear and intuitive. As a passionate startup, we leverage cutting-edge tech to solve intricate business challenges, delivering solutions that drive real value and a distinct competitive advantage.',
      p2: "Our lean, expert-led teams are at the forefront of innovation, helping businesses of all sizes embrace digital transformation and achieve unprecedented growth through intelligent automation and data-driven insights.",
      stat1: { label: 'Agile Teams', value: 'Expert-Led' },
      stat2: { label: 'Client-First', value: 'Focus' },
      stat3: { label: 'Global', value: 'Mindset' },
      values: [
        'Innovation-driven approach to every project',
        'Client-centric solutions tailored to your needs',
        'Cutting-edge technology and best practices',
        'Transparent communication throughout the process',
        'Continuous support and optimization',
        'Results-focused delivery with measurable outcomes'
      ]
    },
    contact: {
      badge: 'Let\'s Collaborate',
      title1: 'Ready to',
      title2: 'Build Together?',
      subtitle: 'Let\'s discuss how we can help transform your business. Our team is ready to partner with you and bring your vision to life.',
      formTitle: 'Send us a message',
      formSuccess: 'Message Sent!',
      formSuccessDesc: 'We\'ll get back to you within 24 hours.',
      formName: 'Name',
      formCompany: 'Company',
      formEmail: 'Email',
      formMessage: 'Message',
      formSubmit: 'Send Message',
      infoTitle: 'Start a conversation',
      infoDesc: "Have a project in mind? We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
      ctaTitle: 'Schedule a free consultation',
      ctaDesc: 'Discuss your project requirements and learn how we can help accelerate your digital transformation journey.',
      contactInfo: [
        { label: 'Email', value: 'contact@lakehouse-technologies.com' },
        { label: 'Phone', value: '+40 723-456-789' },
        { label: 'Office', value: 'Bucharest, Romania' }
      ]
    },
    footer: {
      desc: 'An innovative startup specializing in AI, software, and digital transformation services. We build intelligent systems with crystal clear solutions.',
      services: 'Services',
      company: 'Company',
      copyright: '© {year} Lakehouse Technologies. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
    tseg: {
      backToHome: 'Back to Home',
      heroTitle: 'Outsmart attackers — train people faster, measure what matters.',
      heroSubtitle: 'A single platform for immersive courses, realistic phishing simulations, and admin-grade analytics — built to scale from teams to enterprise.',
      requestDemo: 'Request a demo',
      contactSales: 'Contact Sales',
      seeAdminTour: 'See admin tour',
      sendingMessage: 'Sending...',
      demoSuccessMessage: 'Demo request sent successfully!',
      salesSuccessMessage: 'Sales team will contact you soon!',
      errorMessage: 'Failed to send request. Please try again.',
      valueProps: {
        card1Title: 'Train.Test.Prove.',
        card1Desc: 'Short, practical courses and real-world tests that actually change behavior.',
        card2Title: 'Admin control, effortless scale.',
        card2Desc: 'Full-suite tools for user management, campaign orchestration, and role-switching to test what your people see.',
        card3Title: 'Measure & report with confidence.',
        card3Desc: 'Actionable dashboards, per-email logs, and one-click exports (PDF/CSV) for audits and leadership updates.'
      },
      safety: {
        title: 'How it makes you safer',
        subtitle: 'Assign focused training, test with realistic scenarios, read clear analytics, and automatically retarget risk — a closed loop that sharpens people, not just checkboxes.'
      },
      users: {
        title: 'For Users: Courses, Tests & Trusted News',
        feature1Title: 'Learner experience',
        feature1Desc: 'Six vendor-tested courses ready to deploy; add your own content to match company voice.',
        feature2Title: 'Integrated tests',
        feature2Desc: 'Integrated tests that feel authentic — not scripted.',
        feature3Title: 'Cybersecurity news feed',
        feature3Desc: 'Compact cybersecurity news feed with curated links to trusted sources so users stay informed without noise.',
        highlight: 'Bite-sized lessons + believable simulations = better retention and faster behavior change.'
      },
      admins: {
        title: 'For Admins: The Power Features',
        card1Title: 'Dual-view admin / user toggle',
        card1Desc: 'See the platform exactly how an employee does — then switch back and act.',
        card2Title: 'Full user management',
        card2Desc: 'Add, update, or remove users; assign tags and preferences for smarter targeting.',
        card3Title: 'Content flexibility',
        card3Desc: 'Use our six ready courses or upload company-specific modules and tests.',
        card4Title: 'Template & sender management',
        card4Desc: 'Add sending addresses, manage templates and leverage AI assistant to draft variants.'
      },
      campaigns: {
        title: 'Campaigns: Two Smart Approaches',
        customTitle: 'Custom Campaigns',
        customDesc: 'Run a focused simulation now or schedule it: pick users individually, by department, or by risk score and send a one-time, precise test.',
        automatedTitle: 'Automated Campaigns',
        automatedDesc: 'Continuous, randomized simulations over chosen windows. Set frequency and time frames; the engine randomizes day/time within those bounds.'
      },
      ai: {
        title: 'AI & Template Matching',
        subtitle: 'Use our AI assistant to draft convincing templates, then let the matching engine pair variants to user profiles so simulations feel human — not templated.',
        badge1: 'AI Draft',
        badge2: 'Smart Matching',
        badge3: 'Personalized Scale'
      },
      security: {
        title: 'Security, Privacy & Compliance',
        subtitle: 'Simulations are controlled, auditable experiments. Secure sending infrastructure, strict admin permissions, minimal metadata collection, and exportable audit trails help you align with internal policy and external compliance needs.',
        card1Title: 'Secure Infrastructure',
        card1Desc: 'Enterprise-grade security with controlled, auditable experiments',
        card2Title: 'Privacy First',
        card2Desc: 'Minimal metadata collection with strict admin permissions',
        card3Title: 'Compliance Ready',
        card3Desc: 'Exportable audit trails for internal policy and external compliance'
      },
      outcomes: {
        title: 'Proof of Impact',
        subtitle: 'Outcomes you can show to leadership and measure over time',
        metric1: '85%',
        metric1Title: 'Faster Remediation',
        metric1Desc: 'After targeted retraining',
        metric2: '72%',
        metric2Title: 'Reduction',
        metric2Desc: 'In repeat clickers',
        metric3: '94%',
        metric3Title: 'Completion Rate',
        metric3Desc: 'Course completion and competency'
      },
      footerCta: {
        title: 'Ready to Transform Your Security Training?',
        subtitle: 'See it live — Request a tailored demo or book a 15-minute admin walkthrough to watch the admin tools and the statistics page in action.'
      }
    }
  },
  ro: {
    navigation: {
      home: 'Acasă',
      products: 'Produse',
      services: 'Servicii',
      team: 'Echipa',
      about: 'Despre Noi',
      contact: 'Contact',
      getStarted: 'Începe Acum',
      language: 'Limbă',
    },
    hero: {
      badge: 'Sisteme Inteligente, Soluții Clare ca Lacrima.',
      title1: 'Construiește Viitorul',
      title2: 'cu Lakehouse',
      subtitle: 'Ca un startup vizionar, livrăm soluții de ultimă generație în AI, software și consultanță strategică pentru a accelera transformarea afacerii tale.',
      cta1: 'Începe Proiectul',
      cta2: 'Explorează Serviciile',
      value1_title: 'Inovație',
      value1_desc: 'În esența noastră',
      value2_title: 'Parteneriat',
      value2_desc: 'În abordarea noastră',
      value3_title: 'Scalabilitate',
      value3_desc: 'În designul nostru',
    },
    products: {
      badge: 'Produsele Noastre',
      title1: 'Proiectate pentru',
      title2: 'Provocări Moderne',
      subtitle: 'Descoperă produsele noastre de referință, concepute pentru a oferi claritate și securitate într-o lume digitală complexă.',
      learnMore: 'Află Mai Mult',
      items: [
        {
          title: 'TSEG - The Social Engineering Guard',
          description: 'Platformă avansată de conștientizare a ingineriei sociale care antrenează și protejează organizația ta împotriva phishing-ului, pretextului și atacurilor cibernetice centrate pe factorul uman.',
          features: ['Simulări de Atacuri Realiste', 'Evaluare Amenințări în Timp Real', 'Analitică Comportamentală', 'Training de Securitate Personalizat'],
        },
        {
          title: 'Nexus Pay',
          description: 'Un ecosistem de plată unificat pentru toate utilitățile rezidențiale. Simplifică facturarea, plățile și managementul comunității cu automatizare inteligentă.',
          features: ['Hub de Facturare Unificat', 'Gateway de Plată Securizat', 'Dashboard Analitică Consum', 'Portal Comunicare Locatari'],
        },
        {
          title: 'Sentinel AI',
          description: 'Expertul tău în securitate cibernetică autonom. Sentinel monitorizează, detectează și neutralizează continuu amenințările cu testare de penetrare avansată bazată pe AI.',
          features: ['Monitorizare Autonomă 24/7', 'Testare Penetrare cu AI', 'Evaluare Vulnerabilități', 'Răspuns Automatizat la Incidente'],
        },
      ],
    },
    services: {
      badge: 'Serviciile Noastre',
      title1: 'Servicii',
      title2: 'Tehnologice de Expertiză',
      subtitle: 'Servicii tehnologice complete, livrate de echipa noastră de experți pentru a accelera transformarea digitală și a stimula creșterea afacerii.',
      processTitle: 'Procesul Nostru Agil',
      processSubtitle: 'O metodologie dovedită care asigură livrarea cu succes a proiectelor și rezultate excepționale.',
      items: [
        { title: 'Dezvoltare și Implementare AI', description: 'Soluții AI personalizate pentru nevoile afacerii tale, de la modele de machine learning la rețele neuronale și sisteme de decizie automate.', benefits: ['Modele ML personalizate', 'Procesarea limbajului natural', 'Viziune computerizată', 'Analiză predictivă'] },
        { title: 'Dezvoltare Software', description: 'Servicii de dezvoltare full-stack pentru crearea de aplicații scalabile, sigure și performante folosind cele mai noi tehnologii.', benefits: ['Aplicații Web', 'Aplicații Mobile', 'Soluții Cloud', 'Dezvoltare API'] },
        { title: 'Consultanță în Automatizare', description: 'Consultanță strategică în automatizare pentru a eficientiza procesele, reduce costurile și îmbunătăți eficiența prin automatizare inteligentă.', benefits: ['Optimizarea Proceselor', 'Automatizarea Fluxurilor', 'Implementare RPA', 'Soluții de Integrare'] },
        { title: 'Analiza Datelor', description: 'Transformă datele în informații acționabile cu soluții avansate de analiză, vizualizare și business intelligence.', benefits: ['Business Intelligence', 'Vizualizarea Datelor', 'Analiză în Timp Real', 'Rapoarte Personalizate'] },
        { title: 'Design și Arhitectură de Sistem', description: 'Servicii de arhitectură și design de sistem la nivel de întreprindere pentru a construi infrastructuri tehnologice robuste, scalabile și mentenabile.', benefits: ['Planificare Arhitectură', 'Design pentru Scalabilitate', 'Optimizarea Performanței', 'Implementare Securitate'] }
      ],
      processSteps: [
        { step: '01', title: 'Descoperire', desc: 'Înțelegerea nevoilor și obiectivelor tale' },
        { step: '02', title: 'Strategie', desc: 'Dezvoltarea abordării perfecte a soluției' },
        { step: '03', title: 'Implementare', desc: 'Construirea și implementarea soluției tale' },
        { step: '04', title: 'Suport', desc: 'Mentenanță și optimizare continuă' }
      ]
    },
    team: {
        badge: 'Expertiza Noastră',
        title1: 'Profesioniști de Elită',
        title2: 'Excelență Dovedită',
        subtitle: 'Cu peste 5 ani de experiență în AI, dezvoltare software, consultanță, data science și analiză de date, echipa noastră aduce expertiză tehnică profundă și experiență diversificată în industrie.',
        areas: [
            { title: 'AI & Machine Learning', description: 'Echipa noastră se specializează în soluții de inteligență artificială și machine learning de ultimă generație, susținute de diplome avansate și experiență extinsă în cercetare.', background: 'Diplome de Master • Cercetare AI • Rețele Neuronale' },
            { title: 'Inginerie Software', description: 'Dezvoltatori full-stack și arhitecți cu licențe în inginerie software și diplome de la cele mai bune universități din România, oferind soluții enterprise scalabile.', background: 'Ingineri Autorizați • Diplome Universități de Top • Arhitectură Enterprise' },
            { title: 'Data Science & Analytics', description: 'Data scientists și analiști experți care transformă seturi complexe de date în informații acționabile folosind metode statistice avansate.', background: 'Analiză Avansată • Modelare Statistică • Business Intelligence' },
            { title: 'Consultanță Tehnică', description: 'Consultanți cu experiență care au lucrat în sectorul guvernamental, privat și în instituții de cercetare, oferind ghidare strategică în tehnologie.', background: 'Proiecte Guvernamentale • Sector Privat • Experiență în Cercetare' },
        ],
        years: 'Ani de Experiență',
        areasLabel: 'Arie de Expertiză Principală',
        academic: 'Background Academic',
        industry: 'Experiență în Industrie',
    },
    about: {
      badge: 'Misiunea Noastră',
      title1: 'Pionierat în',
      title2: 'Claritate Digitală',
      subtitle1: 'De la Probleme Complexe la',
      subtitle2: 'Soluții Elegante',
      p1: 'Lakehouse Technologies a fost fondată pe principiul că și cea mai complexă tehnologie ar trebui să pară clară și intuitivă. Ca un startup pasionat, folosim tehnologie de vârf pentru a rezolva provocări complexe, livrând soluții care aduc valoare reală și un avantaj competitiv distinct.',
      p2: 'Echipele noastre agile, conduse de experți, sunt în prima linie a inovației, ajutând companiile de toate dimensiunile să adopte transformarea digitală și să atingă o creștere fără precedent prin automatizare inteligentă și informații bazate pe date.',
      stat1: { label: 'Echipe Agile', value: 'Conduse de Experți' },
      stat2: { label: 'Clientul pe Primul Loc', value: 'Focalizare' },
      stat3: { label: 'Mentalitate', value: 'Globală' },
      values: [
        'Abordare bazată pe inovație în fiecare proiect',
        'Soluții centrate pe client, adaptate nevoilor tale',
        'Tehnologie de vârf și cele mai bune practici',
        'Comunicare transparentă pe tot parcursul procesului',
        'Suport și optimizare continuă',
        'Livrare axată pe rezultate, cu rezultate măsurabile'
      ]
    },
    contact: {
      badge: 'Să Colaborăm',
      title1: 'Ești gata să',
      title2: 'Construim Împreună?',
      subtitle: 'Hai să discutăm cum te putem ajuta să-ți transformi afacerea. Echipa noastră este pregătită să colaboreze cu tine și să-ți aducă viziunea la viață.',
      formTitle: 'Trimite-ne un mesaj',
      formSuccess: 'Mesaj Trimis!',
      formSuccessDesc: 'Vom reveni în 24 de ore.',
      formName: 'Nume',
      formCompany: 'Companie',
      formEmail: 'Email',
      formMessage: 'Mesaj',
      formSubmit: 'Trimite Mesajul',
      infoTitle: 'Începe o conversație',
      infoDesc: 'Ai un proiect în minte? Ne-ar plăcea să aflăm mai multe. Trimite-ne un mesaj și îți vom răspunde cât mai curând posibil.',
      ctaTitle: 'Programează o consultație gratuită',
      ctaDesc: 'Discută cerințele proiectului tău și află cum te putem ajuta să accelerezi călătoria ta de transformare digitală.',
      contactInfo: [
        { label: 'Email', value: 'contact@lakehouse-technologies.com' },
        { label: 'Telefon', value: '+40 723-456-789' },
        { label: 'Birou', value: 'București, România' }
      ]
    },
    footer: {
      desc: 'Un startup inovator specializat în AI, software și servicii de transformare digitală. Construim sisteme inteligente cu soluții clare.',
      services: 'Servicii',
      company: 'Companie',
      copyright: '© {year} Lakehouse Technologies. Toate drepturile rezervate.',
      privacy: 'Politica de Confidențialitate',
      terms: 'Termeni și Condiții',
    },
    tseg: {
      backToHome: 'Înapoi la Pagina Principală',
      heroTitle: 'Cu un pas înaintea atacatorilor — antrenează oamenii mai rapid, analizează rezultatele.',
      heroSubtitle: 'O singură platformă pentru cursuri immersive, simulări realiste de phishing și analize la nivel de administrator — construită pentru a scala de la echipe la întreprinderi.',
      requestDemo: 'Solicită o demonstrație',
      contactSales: 'Contactează Vânzări',
      seeAdminTour: 'Vezi turul pentru administratori',
      sendingMessage: 'Se trimite...',
      demoSuccessMessage: 'Cererea de demonstrație a fost trimisă cu succes!',
      salesSuccessMessage: 'Echipa de vânzări te va contacta în curând!',
      errorMessage: 'Eroare la trimiterea cererii. Te rugăm să încerci din nou.',
      valueProps: {
        card1Title: 'Antrenează.Testează.Dovedește.',
        card1Desc: 'Cursuri scurte, practice și teste din lumea reală care schimbă cu adevărat comportamentul.',
        card2Title: 'Control administrativ, scalare fără efort.',
        card2Desc: 'Instrumente complete pentru gestionarea utilizatorilor, orchestrarea campaniilor și schimbarea rolurilor pentru a testa ceea ce văd oamenii tăi.',
        card3Title: 'Măsoară și raportează cu încredere.',
        card3Desc: 'Dashboard-uri acționabile, statistici per email și export cu un click (PDF/CSV) pentru audituri și actualizări pentru conducere.'
      },
      safety: {
        title: 'Cum te face mai sigur',
        subtitle: 'Atribuie antrenamente focalizate, testează cu scenarii realiste, citește analize clare și targetează automat riscul — un ciclu închis care antrenează oamenii, nu doar bifează căsuțe.'
      },
      users: {
        title: 'Pentru Utilizatori: Cursuri, Teste & Știri de Încredere',
        feature1Title: 'Experiența cursantului',
        feature1Desc: 'Șase cursuri testate, gata de implementat; adaugă propriul conținut pentru a se potrivi vocii companiei.',
        feature2Title: 'Teste integrate',
        feature2Desc: 'Teste integrate care par autentice — nu scriptate.',
        feature3Title: 'Feed cu știri de securitate cibernetică',
        feature3Desc: 'Feed compact cu știri de securitate cibernetică, link-uri către surse de încredere, utilizatori bine informați.',
        highlight: 'Lecții mici + simulări credibile = retenție mai bună și schimbare mai rapidă a comportamentului.'
      },
      admins: {
        title: 'Pentru Administratori: Funcționalități Puternice',
        card1Title: 'Comutare dublă admin / utilizator',
        card1Desc: 'Vezi platforma exact cum o vede un angajat — comută înapoi și acționează.',
        card2Title: 'Gestionare completă utilizatori',
        card2Desc: 'Adaugă, actualizează sau elimină utilizatori; atribuie etichete și preferințe pentru o direcționare mai inteligentă.',
        card3Title: 'Flexibilitate conținut',
        card3Desc: 'Folosește unul dinte cursurile gandite de noi sau creează module și teste specifice companiei.',
        card4Title: 'Gestionare șabloane & expeditori',
        card4Desc: 'Adaugă adrese de expediere, gestionează șabloane și folosește asistentul AI pentru a crea variante.'
      },
      campaigns: {
        title: 'Campanii: Două Abordări Inteligente',
        customTitle: 'Campanii Personalizate',
        customDesc: 'Rulează o simulare focalizată acum sau programează-o: alege utilizatori individual, pe departament sau după scorul de risc și trimite un test unic, precis.',
        automatedTitle: 'Campanii Automatizate',
        automatedDesc: 'Simulări continue croite pentru etichetele utilizatorilor. Setează frecvența și intervalele de timp; algoritmul va alege aleator ziua/ora în intervalul ales.'
      },
      ai: {
        title: 'AI & Clasificarea Utilizatorilor',
        subtitle: 'Folosește asistentul nostru AI pentru a crea șabloane convingătoare, apoi lasă algoritmul de clasificare să asocieze variante cu profilurile utilizatorilor, astfel încât simulările să pară umane — nu șablonate.',
        badge1: 'Draft AI',
        badge2: 'Clasificare Inteligentă',
        badge3: 'Scalare Personalizată'
      },
      security: {
        title: 'Securitate, Confidențialitate & Conformitate',
        subtitle: 'Simulările sunt experimente controlate, auditabile. Infrastructură de trimitere securizată, permisiuni stricte de administrator, colectare minimă de metadate și analize de audit exportabile te ajută să te aliniezi cu politica internă și cerințele de conformitate externe.',
        card1Title: 'Infrastructură Securizată',
        card1Desc: 'Securitate la nivel enterprise cu experimente controlate, auditabile',
        card2Title: 'Confidențialitate Prioritară',
        card2Desc: 'Colectare minimă de metadate cu permisiuni stricte de administrator',
        card3Title: 'Pregătit pentru Conformitate',
        card3Desc: 'Analize de audit exportabile pentru politica internă și conformitate externă'
      },
      outcomes: {
        title: 'Dovada Impactului',
        subtitle: 'Rezultate actionabile și măsurabile în timp',
        metric1: '85%',
        metric1Title: 'Remediere Mai Rapidă',
        metric1Desc: 'După antrenament țintit',
        metric2: '72%',
        metric2Title: 'Reducere',
        metric2Desc: 'În clickuri repetate',
        metric3: '94%',
        metric3Title: 'Rată de Finalizare',
        metric3Desc: 'Finalizare curs și competență'
      },
      footerCta: {
        title: 'Gata să Îți Transformi Antrenamentul de Securitate?',
        subtitle: 'Solicită o demonstrație personalizată sau programează o prezentare de 15 minute pentru a vedea instrumentele de administrator și pagina de statistici în acțiune.'
      }
    }
  }
};
